import React from 'react';
import {reduxForm} from 'redux-form';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import Grid from 'infrastructure/js/components/Grid/gridWrapper';
import MaterialsCell         from './CustomCells/MaterialsCell/materialsCell';
import {filterTypes} from 'infrastructure/js/enums/filterTypes';
import LabelWithTooltipCell from '../../../../Common/CustomGridCells/LabelWithTooltipCell/labelWithTooltipCell';
import {FetchEntitiesFilters} from '../../../../../enums/fetchEntitiesFilters';
import {EntityPropertyTypes} from '../../../../../enums/entityPropertyTypes';
import {filterAlignmentTypes} from 'infrastructure/js/enums/filterAlignmentTypes';
import {gridsNames} from '../../../../../enums/gridsNames';

class KitTypesViewGrid extends React.PureComponent{

  filterConfig = [
    {fieldName: 'businessId', filterName: 'kitTypeBusinessId', getOptions: false},
    {fieldName: 'revision', filterName: 'kitTypeRevision', getOptions: true},
    {fieldName: 'partType.businessId', filterName: 'kitTypePart', getOptions: false},
    {fieldName: 'project.businessId', filterName: 'kitTypeProject', getOptions: true},
  ];


  constructor (props){
    super(props);

    this.labels = createLabelHelper('mat.grid.');
    this.isArchived = props.gridName === gridsNames.ADMINISTRATION_MAT_SETTINGS_ARCHIVED_KIT_TYPES;

    this.columnsConfig = this.createColumnsConfig();
  }

  createColumnsConfig = () => {
    return [
      {
        fieldName: 'businessId',
        title: this.labels.get('columns.kitType.title'),
        filterType: filterTypes.MULTI_SELECT_ASYNC,
        filterName: 'kitTypeBusinessId',
        fetchConfig: {
          entityType: EntityPropertyTypes.KIT_TYPE_BUSINESS_ID,
          filter: this.isArchived ? [FetchEntitiesFilters.ARCHIVED] : [FetchEntitiesFilters.ACTIVE],
          action: this.props.actions.fetchEntities
        },
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'revision',
        title: this.labels.get('columns.kitTypeVersion.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'kitTypeRevision',
      },
      {
        fieldName: 'kitTypeMaterials',
        title: this.labels.get('columns.expectedMaterials.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          sortable: false,
          cellComponent: MaterialsCell,
        }
      },
      {
        fieldName: 'partType.businessId',
        title: this.labels.get('columns.partType.title'),
        filterType: filterTypes.MULTI_SELECT_ASYNC,
        filterName: 'kitTypePart',
        fetchConfig: {
          entityType: EntityPropertyTypes.PART_TYPE_BUSINESS_ID,
          // filter: BO_EntityFilters.ALL,
          filter: [FetchEntitiesFilters.ALL],
          action: this.props.actions.fetchEntities
        },
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'project.businessId',
        title: this.labels.get('columns.project.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'kitTypeProject',
        filterAlignment: filterAlignmentTypes.RIGHT,
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
        }
      },
    ]
  };

  getRowHeight(params) {
    let rowHeight = 64;
    // increase row height for rows with many materials types
    if (params.data.kitTypeMaterials.length > 0) {
      let subMaterialRowsNum = params.data.kitTypeMaterials.reduce((previous, current) => {
            let cur = (current && current.substituteMaterials) ?  current.substituteMaterials.length : 0;

            return previous + cur;
          }, 0);

      rowHeight = (params.data.kitTypeMaterials.length * 45 + subMaterialRowsNum * 25 ) + 40;
    }

    return rowHeight;
  }

  render() {
    return (
      <div className="administration-view-grid">
        <Grid gridName={this.props.gridName}
              columnsConfig = {this.columnsConfig}
              actions={this.props.actions}
              filterConfig={this.filterConfig}
              gridProps={
                {
                  getRowHeight: this.getRowHeight,
                }
              }
        >
        </Grid>
      </div>
    );
  }
}

export default reduxForm({
    form: 'kitTypesViewGrid'
  }
)(KitTypesViewGrid);
